import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMiniappSdk } from 'app/shared/contexts/miniapp-sdk';
import { useOpenParams } from 'app/shared/hooks/use-open-params';

/**
 * Back/close handler shared by the content view and its loading skeleton, so the
 * skeleton's back control behaves exactly like the loaded view's. If the miniapp was
 * opened directly to this content (the initial url carries the content uuid), "back"
 * closes the miniapp; otherwise it pops the in-app history. Keyed on the content uuid
 * taken from the URL (not the loaded entity) so it works during loading, before the
 * content has resolved.
 */
export const useContentBackNavigation = (): (() => void) => {
  const { initialUrl } = useOpenParams();
  const client = useMiniappSdk();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const contentUuid = pathname.split('/').filter(Boolean).pop();

  return useCallback(() => {
    if (initialUrl && contentUuid && initialUrl.includes(contentUuid)) {
      client?.close();
    } else {
      navigate(-1);
    }
  }, [client, navigate, initialUrl, contentUuid]);
};
